import { useMemo, useContext, useEffect } from "react";
import { PropertyHistoryModal, PaginationContext } from "dash-ui";
import { useGetPropertyChangelogsQuery } from "gql/generated.graphql";

interface PropertyHistoryModalWithPaginationProps {
  isOpen: boolean;
  onClose: () => void;
  propertyId?: string;
  hasChangelog?: boolean;
}

function PropertyHistoryModalWithPagination({
  isOpen,
  onClose,
  propertyId,
  hasChangelog,
}: PropertyHistoryModalWithPaginationProps) {
  const { getRefetchProps, state, setTotal } = useContext(PaginationContext);
  const pagination = getRefetchProps(state);

  const { data: changelogsData, loading: changelogsLoading } =
    useGetPropertyChangelogsQuery({
      variables: {
        filter: { propertyId: propertyId },
        pagination,
        sort: [{ fieldName: "createdAt", sortOrder: -1 }],
      },
      fetchPolicy: "network-only",
      skip: !hasChangelog || !isOpen,
    });

  const { history, totalCount } = useMemo(
    () => ({
      history: changelogsData?.getPropertyChangelogs?.collection || [],
      totalCount: changelogsData?.getPropertyChangelogs?.totalCount || 0,
    }),
    [changelogsData]
  );

  // Set total count for pagination
  useEffect(() => {
    if (totalCount) {
      setTotal(totalCount);
    }
  }, [totalCount, setTotal]);

  return (
    <PropertyHistoryModal
      isOpen={isOpen}
      onClose={onClose}
      loading={changelogsLoading}
      data={history}
    />
  );
}

export default PropertyHistoryModalWithPagination;